export interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  weight: string;
  image: string;
  category: string;
  badge?: string;
  rating: number;
  reviews: number;
}

export const products: Product[] = [
  {
    id: 'prod-1',
    name: 'Premium Afghan Green Tea',
    description: 'Hand-picked green tea leaves from the highlands of Afghanistan. Mild, earthy flavor with a smooth finish. Perfect for daily brewing.',
    price: '$12.99',
    weight: '250g',
    image: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/4b60b7d2a78bd53f81769c14c116903f.jpeg',
    category: 'Green Tea',
    badge: 'Best Seller',
    rating: 4.9,
    reviews: 128,
  },
  {
    id: 'prod-2',
    name: 'Saffron Infused Green Tea',
    description: 'Luxurious green tea blended with premium Kashmiri saffron strands. A golden brew with a delicate floral aroma and rich taste.',
    price: '$18.99',
    weight: '200g',
    image: 'https://readdy.ai/api/search-image?query=Premium%20saffron%20green%20tea%20package%20with%20golden%20saffron%20strands%20on%20warm%20cream%20background%2C%20elegant%20tea%20product%20photography%2C%20soft%20natural%20lighting&width=800&height=800&seq=product-saffron-01&orientation=squarish',
    category: 'Specialty',
    badge: 'Premium',
    rating: 4.8,
    reviews: 84,
  },
  {
    id: 'prod-3',
    name: 'Cardamom Green Tea',
    description: 'Aromatic green tea infused with crushed green cardamom pods. Warming, fragrant, and deeply satisfying.',
    price: '$14.99',
    weight: '250g',
    image: 'https://readdy.ai/api/search-image?query=Green%20tea%20package%20with%20cardamom%20pods%20on%20warm%20neutral%20background%2C%20premium%20tea%20product%20photography%2C%20soft%20lighting%2C%20clean%20minimal%20composition&width=800&height=800&seq=product-cardamom-01&orientation=squarish',
    category: 'Green Tea',
    rating: 4.7,
    reviews: 96,
  },
  {
    id: 'prod-4',
    name: 'Jasmine Blossom Green Tea',
    description: 'Delicate green tea leaves layered with fresh jasmine blossoms. A light, floral, and incredibly soothing cup.',
    price: '$15.99',
    weight: '200g',
    image: 'https://readdy.ai/api/search-image?query=Jasmine%20green%20tea%20package%20with%20white%20jasmine%20flowers%20on%20soft%20cream%20background%2C%20premium%20tea%20product%20photography%2C%20elegant%20minimal%20style&width=800&height=800&seq=product-jasmine-01&orientation=squarish',
    category: 'Specialty',
    rating: 4.8,
    reviews: 72,
  },
  {
    id: 'prod-5',
    name: 'Rose Petal Green Tea',
    description: 'Green tea blended with dried rose petals for a romantic, fragrant brew. Beautiful pink hue and calming flavor.',
    price: '$16.99',
    weight: '200g',
    image: 'https://readdy.ai/api/search-image?query=Rose%20petal%20green%20tea%20package%20with%20pink%20dried%20rose%20petals%20on%20warm%20cream%20background%2C%20premium%20tea%20product%20photography%2C%20soft%20lighting&width=800&height=800&seq=product-rose-01&orientation=squarish',
    category: 'Specialty',
    rating: 4.6,
    reviews: 58,
  },
  {
    id: 'prod-6',
    name: 'Mint Refresh Green Tea',
    description: 'Invigorating green tea combined with fresh dried mint leaves. Crisp, clean, and perfectly refreshing.',
    price: '$13.99',
    weight: '250g',
    image: 'https://readdy.ai/api/search-image?query=Green%20tea%20package%20with%20fresh%20mint%20leaves%20on%20warm%20neutral%20background%2C%20premium%20tea%20product%20photography%2C%20clean%20minimal%20composition%2C%20soft%20natural%20lighting&width=800&height=800&seq=product-mint-01&orientation=squarish',
    category: 'Green Tea',
    rating: 4.7,
    reviews: 104,
  },
];